import React, { Component } from "react";

import { AppContext } from "../App";
import DeleteDialog from "./DeleteDialog";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import RadioButtonChecked from "@material-ui/icons/RadioButtonChecked";
import RadioButtonUnchecked from "@material-ui/icons/RadioButtonUnchecked";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";

import { Link } from "react-router-dom";

import { authenticated } from "../services/auth";
import Loader from "../components-utils/Loader";

import "./List.css";

class List extends Component {
  state = {
    openDialog: false
  };

  async componentDidMount() {
    const { getItems, snackbar } = this.props;
    try {
      const auth = authenticated();
      const items = await getItems(auth.currentMerchant.code);
      this.setState({ items, merchantCode: auth.currentMerchant.code });
    } catch (error) {
      this.setState(
        { items: [] },
        snackbar(
          "Une erreur est survenue pendant la récupération des données. Merci de recharger la page",
          "error"
        )
      );
    }
  }

  manageReorder = (target, position) => async e => {
    e.stopPropagation();
    const { selected, merchantCode } = this.state;
    const { snackbar, reorderItem } = this.props;
    try {
      const items = await reorderItem(merchantCode, selected, position, target);
      this.setState({ items });
    } catch (e) {
      snackbar(
        "Une erreur est survenue pendant la réorganisation. veuillez réessayer",
        "error"
      );
    }
  };

  manageDefault = id => async e => {
    e.stopPropagation();
    const { merchantCode } = this.state;
    const { snackbar, setDefaultItem } = this.props;
    try {
      const items = await setDefaultItem(id, merchantCode);
      this.setState({ items });
    } catch (e) {
      snackbar(
        "Une erreur est survenue pendant la réorganisation. veuillez réessayer",
        "error"
      );
    }
  };

  selectItem = id => () => {
    this.setState({ selected: this.state.selected === id ? undefined : id });
  };

  deleteItem = async () => {
    const { snackbar, getItems, deleteItem } = this.props;
    const { merchantCode } = this.state;
    try {
      await deleteItem(this.state.itemToDelete, merchantCode);
      const items = await getItems(merchantCode);
      this.setState({ items }, () => snackbar(`Élément supprimé`));
    } catch (error) {
      console.error(error);
      snackbar(error.error, "error");
    }
    this.closeDeleteDialog();
  };

  openDeleteDialog = id => e => {
    e.stopPropagation();
    this.setState({
      openDialog: true,
      itemToDelete: id
    });
  };
  closeDeleteDialog = () => {
    this.setState({ openDialog: false });
  };

  renderActionButton() {
    const { selected } = this.state;
    const { path } = this.props;
    return (
      <Link
        key="action"
        to={`${path}/${selected !== undefined ? selected : "new"}`}
      >
        <Button
          className="sp-list--actionbutton"
          variant="fab"
          color="secondary"
          aria-label="add"
        >
          {selected !== undefined ? <EditIcon /> : <AddIcon />}
        </Button>
      </Link>
    );
  }

  renderTable() {
    const { openDialog, items, selected } = this.state;
    const {
      deleteItem,
      reorderItem,
      elementName,
      elementGender,
      hasDefault
    } = this.props;
    return [
      <Paper key="page">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Libellé</TableCell>
              {hasDefault && <TableCell width="50px">Défaut</TableCell>}
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {items.length > 0 ? (
              items.map(item => {
                const { id, value, technicalLabel } = item;
                return (
                  <TableRow
                    key={id}
                    className="sp-list--item"
                    onClick={this.selectItem(id)}
                    role="checkbox"
                    aria-checked={selected === id}
                    selected={selected === id}
                  >
                    <TableCell
                      padding="checkbox"
                      className="sp-list--checkboxcell"
                    >
                      <Checkbox
                        checked={selected === id}
                        value={`selected-${id}`}
                        color="primary"
                      />
                    </TableCell>
                    <TableCell>
                      {value !== undefined
                        ? value.technicalLabel
                        : technicalLabel}
                    </TableCell>
                    {hasDefault && (
                      <TableCell>
                        <IconButton onClick={this.manageDefault(id)}>
                          {item && item.default ? (
                            <RadioButtonChecked />
                          ) : (
                            <RadioButtonUnchecked />
                          )}
                        </IconButton>
                      </TableCell>
                    )}
                    <TableCell className="sp-list--rowbuttons" numeric>
                      {reorderItem !== undefined &&
                        selected !== undefined &&
                        selected !== id && (
                          <div>
                            <IconButton
                              onClick={this.manageReorder(id, "after")}
                            >
                              <ArrowDownwardIcon />
                            </IconButton>
                            <IconButton
                              onClick={this.manageReorder(id, "before")}
                            >
                              <ArrowUpwardIcon />
                            </IconButton>
                          </div>
                        )}
                      {deleteItem !== undefined &&
                        selected === undefined && (
                          <IconButton
                            aria-label="Supprimer"
                            onClick={this.openDeleteDialog(id)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan="3">
                  Aucun{elementGender === "f" ? "e" : ""} {elementName}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>,
      this.renderActionButton(),
      <DeleteDialog
        key="dialog"
        openDialog={openDialog}
        elementName={elementName}
        elementGender={elementGender}
        closeDeleteDialog={this.closeDeleteDialog}
        deleteItem={this.deleteItem}
      />
    ];
  }
  renderLoader() {
    return <Loader loading={true} />;
  }
  render() {
    const { items } = this.state;

    return items !== undefined ? this.renderTable() : this.renderLoader();
  }
}

const enhanced = WrappedComponent => props => {
  return (
    <AppContext.Consumer>
      {app => <WrappedComponent {...props} snackbar={app.snackbar.open} />}
    </AppContext.Consumer>
  );
};
export default enhanced(List);



// WEBPACK FOOTER //
// ./src/components-utils/List.js